export const BUSINESS_FILTER_TABS = [
  {
    key: "enabled",
    label: "Active",
    labelKey: "stores.tabs.active",
    color: "text-success",
  },
  {
    key: "disabled",
    label: "Inactive",
    labelKey: "stores.tabs.inactive",
    color: "text-error",
  },
  {
    key: "all",
    label: "All Stores",
    labelKey: "stores.tabs.all",
    color: "text-foreground",
  },
];

export const BUSINESS_ITEMS_PER_PAGE = 12;
